module.exports = __webpack_public_path__ + "static/media/παρεμβάσεις_cover.a759aa4e.jpg";